var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.64,
    height: 33.757,
    viewBox: "0 0 35.64 33.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M47.336-458.948a1.809,1.809,0,0,0-.665.432c-.316.308-.607.906-2.71,5.653-2.253,5.079-2.361,5.346-2.361,5.828a2.219,2.219,0,0,0,1.555,2.078,5.348,5.348,0,0,0,2.053.042,2.358,2.358,0,0,0,1.3-.964c.158-.274.757-2.294,2-6.759.973-3.5,1.771-6.376,1.771-6.393A24.627,24.627,0,0,0,47.336-458.948Z",
    transform: "translate(-41.6 459.052)",
    fill: "#ff1c51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M132.69-458.975c0,.017-.715,2.594-1.6,5.72-1.8,6.468-1.812,6.484-1.347,7.307a2.4,2.4,0,0,0,1.347,1.081,8.041,8.041,0,0,0,2.278,0,2.4,2.4,0,0,0,1.33-1.056c.241-.424.258-.549.939-6.651.391-3.417.707-6.268.707-6.327,0-.075-.424-.1-1.829-.1C133.513-459,132.69-458.983,132.69-458.975Z",
    transform: "translate(-122.182 459.004)",
    fill: "#ff1c51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M219.991-458.781c-.025.058-.316,2.694-.665,5.844-.615,5.6-.632,5.753-.507,6.235a2.4,2.4,0,0,0,.815,1.347c.574.524,1,.648,2.261.648a3,3,0,0,0,1.521-.2,2.813,2.813,0,0,0,1.546-2.17c.025-.158-.241-2.876-.6-6.027l-.64-5.736-1.854-.025C220.432-458.881,220.016-458.864,219.991-458.781Z",
    transform: "translate(-204.03 458.885)",
    fill: "#ff1c51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M300-458.9c0,.058.316,2.91.7,6.327.69,6.11.707,6.218.948,6.651a2.4,2.4,0,0,0,1.33,1.056,8.041,8.041,0,0,0,2.278,0,2.4,2.4,0,0,0,1.347-1.081c.466-.823.457-.84-1.347-7.3-.881-3.126-1.6-5.695-1.6-5.72s-.823-.033-1.829-.033C300.424-459,300-458.975,300-458.9Z",
    transform: "translate(-278.518 459.004)",
    fill: "#ff1c51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M366.316-458.859c.025.083.831,2.993,1.8,6.468,1.954,7.033,1.879,6.817,2.743,7.307a2.109,2.109,0,0,0,1.255.283,2.586,2.586,0,0,0,2.087-.565,2.058,2.058,0,0,0,.757-1.638c0-.49-.108-.748-2.353-5.819-2.095-4.722-2.394-5.337-2.7-5.645-.466-.449-.823-.532-2.369-.532C366.366-459,366.274-458.992,366.316-458.859Z",
    transform: "translate(-339.314 459.004)",
    fill: "#ff1c51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M85.816-286.467A4.383,4.383,0,0,1,84-285.32a5.166,5.166,0,0,1-1.713.166,4.032,4.032,0,0,1-3.35-1.122l-.457-.441-.266.3a4.208,4.208,0,0,1-2.76,1.264H75v8.588c0,7.8.008,8.6.133,8.779.266.374.557.424,2.486.424h1.787l.017-6.859.025-6.859.233-.224.224-.233,3.824-.025c3.367-.017,3.857-.008,4.082.108.507.266.49.05.49,7.4v6.692h7.981c8.6,0,8.372.008,8.679-.424.125-.175.133-.981.133-8.779v-8.588h-.449a4.208,4.208,0,0,1-2.76-1.264l-.266-.3-.457.441a4.032,4.032,0,0,1-3.35,1.122,5.166,5.166,0,0,1-1.713-.166,4.383,4.383,0,0,1-1.821-1.147L94-286.8l-.524.482a4.443,4.443,0,0,1-2.02,1.081,8.013,8.013,0,0,1-1.663.067,4.77,4.77,0,0,1-1.7-.216,4.876,4.876,0,0,1-1.688-1.089l-.316-.324Zm14.6,5.163.233.224.025,3.824c.025,4.256.025,4.223-.524,4.456a45.524,45.524,0,0,1-6.9,0c-.549-.233-.549-.2-.524-4.448.025-3.683.033-3.824.191-4a1.288,1.288,0,0,1,.333-.258c.091-.033,1.688-.058,3.55-.05l3.392.017Z",
    transform: "translate(-72.224 301.12)",
    fill: "#ff1c51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.7a3e31daff10dccf59665bf9dc68b28b.svg";
export { ForwardRef as ReactComponent };